import React from 'react'
import PropTypes from 'prop-types'
import { colors } from 'globalStyles'
import Accordion from 'react-bootstrap/Accordion'
import styled from 'styled-components'

const StyledAccordion = styled(Accordion)`
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px 8px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  width: 100%;

  .accordion-item {
    border: none;
  }

  .accordion-header {
    border-block: 1px solid ${colors.grey_light};
  }

  .accordion-body {
    border-bottom: 1px solid ${colors.grey_light};
    padding: 0 !important;
  }
`

const ReactAccordion = ({ defaultActiveKey, items, alwaysOpen, flush }) => {
  return (
    <StyledAccordion defaultActiveKey={defaultActiveKey} alwaysOpen={alwaysOpen} flush={flush}>
      {items.map((item, idx) => (
        <Accordion.Item key={idx} eventKey={idx}>
          <Accordion.Header>{item.heading}</Accordion.Header>
          <Accordion.Body>{item.body}</Accordion.Body>
        </Accordion.Item>
      ))}
    </StyledAccordion>
  )
}

const itemPropType = PropTypes.shape({
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
})

ReactAccordion.propTypes = {
  defaultActiveKey: PropTypes.string,
  items: PropTypes.arrayOf(itemPropType).isRequired,
  alwaysOpen: PropTypes.bool,
  flush: PropTypes.bool,
}

ReactAccordion.defaultProps = {
  defaultActiveKey: '0',
  alwaysOpen: true, // Default to single-expand
  flush: false, // Flush renders accordion edge-to-edge with its parent container.
}

export default ReactAccordion
